/**
 * AI Provider API client.
 * Handles AI provider and model selection endpoints.
 */

import apiClient from './client'

export interface UserAIPreferences {
  provider: string | null
  model: string | null
  latex_compiler: string | null
  available_providers: string[]
  provider_models: Record<string, string[]>
}

export interface UpdateAIPreferencesRequest {
  provider?: string | null
  model?: string | null
  latex_compiler?: string | null
}

export const aiProvidersAPI = {
  /**
   * Get list of available AI providers.
   */
  async getAvailableProviders(): Promise<string[]> {
    return apiClient.get('/api/ai/providers')
  },

  /**
   * Get available models for a specific provider.
   */
  async getProviderModels(provider: string): Promise<string[]> {
    return apiClient.get('/api/ai/models', { provider })
  },

  /**
   * Get current user's AI preferences.
   */
  async getPreferences(): Promise<UserAIPreferences> {
    return apiClient.get('/api/ai/preferences')
  },

  /**
   * Update user's AI provider and/or model preferences.
   */
  async updatePreferences(data: UpdateAIPreferencesRequest): Promise<UserAIPreferences> {
    return apiClient.put('/api/ai/preferences', data)
  },
}

